export const deliveryCityStorageKey = 'sshop-delivery-city';
